import { useQueryHelper } from '@anytag/shared-hooks';
import { SocialAccountType, useRefreshProfileAudienceMutation } from '@anytag/graphql';
import { RefreshProfileButton } from './refresh-profile-button';

interface ThreadsRefreshButtonProps {
  className?: string;
  socialAccountId: number;
  socialMedia: SocialAccountType;
  refetchQueries: string[];
}
export const ThreadsRefreshButton = ({
  className,
  socialMedia,
  refetchQueries,
  socialAccountId
}: ThreadsRefreshButtonProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { callRefreshProfileAudience, loading } = useRefreshProfileAudienceMutation({ refetchQueries });

  const handleRefresh = async () => {
    try {
      await callRefreshProfileAudience({
        variables: { input: { socialAccountId, socialAccountType: socialMedia } }
      });

      enqueueSnackbar(t('Account data refreshed successfully'), { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  return (
    <RefreshProfileButton
      loading={loading}
      className={className}
      onClick={handleRefresh}
      title={t('Button.Refresh Profile Audience')}
    />
  );
};
